import React, { useContext, useMemo } from 'react';
import cn from 'classnames';
import ResultsItem from './ResultsItem';
import { DictionariesContext } from '@/creditflowresearch/application/Dictionaries/DictionariesContext';
import { useHeaderMenuContext as useHeaderMenuContextV2 } from '@/creditflowresearch/application/HeaderMenu/HeaderMenuContext';
import { IRegion } from '@/creditflowresearch/domain/vo/Region';

import styles from './resultsColumn.module.scss';
import headerStyles from '@/creditflowresearch/ui/common/components/header/Header/header.module.scss';

interface IProps {
  product: any,
  searchResult: any,
  onSearchResultItemClick: () => void,
  activeItemName: string,
  variant?: 'default' | 'creditflow',
}

const ResultsColumn = ({ activeItemName = '', searchResult, product, onSearchResultItemClick, variant }: IProps) => {
  const legacy = useContext(DictionariesContext);
  const { regions: v2Regions } = useHeaderMenuContextV2();
  const regionsList = legacy?.regionsList ?? v2Regions;
  const reversedRegions = useMemo(() => [...regionsList].reverse(), [regionsList]);
  const renderItem = (region: IRegion) => {
    const key = `${ product.abbreviation.toLowerCase() }_${ region.abbreviation.toLowerCase() }`;
    const data = searchResult.deals && searchResult.deals[key] ? searchResult.deals[key].collection : [];

    return (
      <ResultsItem
        productAbbreviation={ product.abbreviation }
        regionAbbreviation={ region.abbreviation }
        activeItemName={ activeItemName }
        key={ region.id }
        title={ region.abbreviation }
        data={ data }
        isBeta={ !product.beta && region.beta }
        onClick={ onSearchResultItemClick }
        variant={ variant }
      />
    );
  };
  return (
    <div className={ cn(styles.column, {
      [styles.noResultsForFirstColumn]: !searchResult.hasFirstColumnData,
    }) }
    >
      <div className={ styles.columnTitle }>
        { product.name } ({ product.abbreviation })
        { product.beta && (
          <span className={ headerStyles.beta }>(Beta)</span>
        ) }
      </div>
      { reversedRegions.map(renderItem) }
    </div>
  );
};

export default ResultsColumn;
